<template>
  <div class="banner">
    <img src="../assets/banner.jpg" style="width: 100%" />
  </div>
  <div class="batch">
    <!-- 批次列表 -->
    <div class="batch_list">
      <div class="batch_item" v-for="item in batchList" :key="item.id">
        <div class="name">{{ item.activityName }}</div>
        <div class="info discription">{{ item.discription }}</div>
        <div class="info">报名时间：{{ item.startTimeStr }} ~ {{ item.endTimeStr }}</div>
        <div class="info count">目前已设置岗位数：{{ item.jobNum || 0 }}</div>
        <div class="actions">
          <el-button type="primary" size="medium" @click.stop="router.push(`/job?activityId=${item.activityId}`)">查看详情</el-button>
        </div>
        <div v-if="item.status === 1" class="status going">报名进行中</div>
        <div v-else-if="item.status === 3" class="status start">报名未开始</div>
        <div v-else-if="item.status === 4" class="status end">报名结束</div>
        <div v-else class="status done">招聘结束</div>
      </div>
    </div>
  </div>
</template>

<script>
import { onActivated, reactive, toRefs, watch, computed } from 'vue';
import ApplicantApi from '../service/api/applicant';
import { formatDate } from '../utils/tools';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

export default {
  name: 'Index',
  components: {},
  setup() {
    const state = reactive({
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      batchList: [],
    });

    const getBatchList = async () => {
      try {
        const respond = await ApplicantApi.getBatchList({
          pageNum: state.pagination.currentPage,
          pageSize: state.pagination.pageSize,
        });
        state.pagination.total = respond.list.length;
        state.batchList = respond.list
          .filter((item) => item.status === 1 || item.status === 3 || item.status === 4)
          .map((item) => ({
            ...item,
            startTimeStr: formatDate('YYYY年MM月DD日 hh:mm:ss', new Date(item.startTime)),
            endTimeStr: formatDate('YYYY年MM月DD日 hh:mm:ss', new Date(item.endTime)),
          }));
      } catch (e) {
        // 处理错误
      }
    };

    watch([() => state.pagination.currentPage], () => {
      getBatchList();
    });
    onActivated(() => getBatchList());

    const store = useStore();
    const isSpecific = computed(() => store.state.isSpecific); //是否是专项招聘
    const isMobile = computed(() => store.state.isMobile);

    return {
      router: useRouter(),
      ...toRefs(state),
      getBatchList,
      isSpecific,
      isMobile,
    };
  },
};
</script>

<style scoped lang="scss">
@import '../style/func.scss';
.banner {
  height: rem(300px);
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: 50% 50%;
  }
}
.batch {
  height: 100%;
  overflow: auto;
  padding: rem(10px) rem(20px) 0 rem(20px);
}
.batch_list {
  .batch_item {
    border-radius: rem(4px);
    border: 1px solid rgba(102, 102, 102, 0.1);
    box-shadow: 0 2px 4px #f9f9f9;
    margin-bottom: rem(20px);
    position: relative;
    overflow: hidden;
    &:hover {
      background: #f9f9f9;
    }
    .name {
      margin-bottom: rem(10px);
      padding: 0 rem(16px);
      height: rem(40px);
      color: #ed4013;
      border-bottom: 1px solid #f7f7f7;
      font-size: rem(18px);
      font-weight: 600;
      display: flex;
      align-items: center;
    }
    .info {
      padding: rem(6px) rem(20px);
      font-size: rem(16px);
      color: #363e4f;
      line-height: rem(24px);
      &.count {
        color: #318eef;
      }
    }
    .actions {
      margin-top: rem(10px);
      padding: 0 rem(10px);
      height: rem(50px);
      border-top: 1px solid #f7f7f7;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
    .status {
      position: absolute;
      right: rem(-100px);
      top: rem(20px);
      width: rem(272px);
      height: rem(42px);
      background: rgba(44, 182, 244, 0.7);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: rem(18px);
      transform: rotate(45deg);
      &.going {
        background: rgba(75, 176, 19, 0.7);
      }
      &.start {
        background: rgba(44, 182, 244, 0.7);
      }
      &.end {
        background: rgba(254, 153, 2, 0.7);
      }
      &.done {
        background: rgba(191, 187, 187, 0.7);
      }
    }
  }
}

.guide {
  font-size: rem(16px);
}

@media screen and (max-width: 600px) {
  .banner {
    height: rem(200px);
  }
}
</style>
